import state from "@/helpers/store/state";
import set from "@/helpers/store/set";

export default {
  namespaced: true,
  state: () => ({}),
  actions: {},
  mutations: { set },
};
